import viMessage from 'Lang/locales/vi.json'
import enMessage from 'Lang/locales/en.json'

import { languageKey } from 'Store/keyStore'

import { createI18n } from 'vue-i18n'
import { ISelectedItem } from '@/models'

export const Language = {
    VN: 'vi',
    EN: 'en-US'
}

const messages = {
    'vi': viMessage,
    'en-US': enMessage,
}

export const LanguageList:ISelectedItem[] = [
    { id: Language.VN, text: "Tiếng Việt" },
    { id: Language.EN, text: "English" }
]

const currentLocale = function () {
    return localStorage.getItem(languageKey.LOCALE) || Language.VN;
}

const i18n = createI18n({
    locale: currentLocale(), // set locale
    messages,
    fallbackLocale: Language.VN
});

export default i18n;

const changeLocale = function (lang:string) {
    let langNeedToChange = lang;
    if (!lang) {
        langNeedToChange = currentLocale() === Language.VN ? Language.EN : Language.VN;
    }
    i18n.global.locale = langNeedToChange;
    localStorage.setItem(languageKey.LOCALE, langNeedToChange);
    return langNeedToChange;
}

export {
    changeLocale,
    currentLocale
}